import React, { useState } from 'react';

import useSpotConfig from '@host-panel/request/config/use-config';

import TitleAndDescription, { HEADER_FONTS } from '../common/description-component';
import { images } from '../../../utils/imagesUtils';

import fileReader from '@spotim/fed-utils/file-reader';
import getImageUrl from 'app/scripts/components/moderation/models/message-entities/abilities/get-image-url';

const LOGO_TENANT_KEY = 'tenant.shared.logo';
const IMAGE_SIZE_LIMIT = 3 * 1000 * 1000;
const OVER_THE_LIMIT_MESSAGE = 'Sorry, Allowed file size is limited to 3 MB.';

const getInitialLogoData = () => ({
  error: null,
  loading: false
});

const LogoUpload = () => {
  const [[logo], setConfig] = useSpotConfig([LOGO_TENANT_KEY], { [LOGO_TENANT_KEY]: null });
  const [logoUploadData, setLogoUploadData] = useState(getInitialLogoData);

  async function onUploadIcon(event) {
    const imageFile = event.target.files[0];
    if (!imageFile) {
      return;
    }
    if (imageFile.size > IMAGE_SIZE_LIMIT) {
      setLogoUploadData(prevLogoData => ({ ...prevLogoData, error: OVER_THE_LIMIT_MESSAGE }));
      return;
    }

    setLogoUploadData(prevLogoData => ({ ...prevLogoData, loading: true }));

    try {
      const rawImage = await fileReader.readAsDataURL(imageFile);
      const data = await images.uploadImage(rawImage);
      if (data.type === 'error') {
        setLogoUploadData({
          error: data.error,
          loading: false
        });
        return;
      }

      setConfig({ key: LOGO_TENANT_KEY, value: data.public_id });
      setLogoUploadData({
        error: null,
        loading: false
      });
    } catch (err) {
      setLogoUploadData({
        error: 'Sorry, something went wrong with the upload.',
        loading: false
      });
    }
  }

  return (
    <div className="logo-upload-container" style={{ position: 'relative' }}>
      <TitleAndDescription titleFont={HEADER_FONTS.Small} title="Site Logo" description="" />
      <div className="logo-upload-spacer" style={{ marginBottom: '10px' }} />
      <div>
        {logo ? (
          <img className="logo-image" src={getImageUrl(logo)} width="100" height="auto" />
        ) : (
          <div className="box">
            Recommended size:
            <br />
            250x250
          </div>
        )}
      </div>

      {logoUploadData.loading && <div className="loading" />}

      <div className="upload-button-container">
        <div className="upload-button">
          {logo ? 'Replace' : 'Upload'}
          <input type="file" accept="image/*" onChange={onUploadIcon} />
        </div>
      </div>
      <div>
        <p style={{ color: 'red', marginTop: '10px' }}>{logoUploadData.error}</p>
      </div>
    </div>
  );
};

export default LogoUpload;
